import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Country } from '../../business/models/country.model';
import { State } from '../../business/models/state.model';
var CountriesService = /** @class */ (function () {
    function CountriesService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    /**
     * returns Array List of Countries
     * @return {Promise<Country[]>}
     */
    CountriesService.prototype.getCountries = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, RESPONSE, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.airportsApiUrl + "/countries";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        if (!RESPONSE) {
                            this._errorHandler.handleError(new Error('API did not return valid countries Obj'));
                        }
                        else {
                            return [2 /*return*/, (RESPONSE || []).map(function (d) { return Country.parse(d); })];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CountriesService.prototype.getStates = function (countryCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, RESPONSE, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.airportsApiUrl + "/states/" + countryCode;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        if (!RESPONSE) {
                            this._errorHandler.handleError(new Error('API did not return valid states Obj'));
                        }
                        else {
                            return [2 /*return*/, (RESPONSE || []).map(function (d) { return State.parse(d); })];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this._errorHandler.handleError(e_2);
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return CountriesService;
}());
export { CountriesService };
